import {useState} from "react";

import {mb, mt} from "@pg-design/helpers-css";

import {CreditValuesEvent} from "../../tracking/analytics/credit_values_event";
import {CreditAlgolyticsViewType} from "../../tracking/types/CreditAlgolyticsViewType";
import {ICreditOffersFilters} from "../../types/ICreditOffersFilters";
import {CreditOffersFilters} from "./CreditOffersFilters";
import {CreditOffersList} from "./CreditOffersList";

export const CreditOffers = () => {
    const [filters, setFilters] = useState<ICreditOffersFilters>({} as ICreditOffersFilters);

    const onFiltersSet = (selectedFilters: ICreditOffersFilters, initialSet?: boolean) => {
        if (!initialSet) {
            CreditValuesEvent({
                credit_period: selectedFilters.period,
                own_contribution_amount: selectedFilters.contribution,
                own_contribution_percent: Math.floor((selectedFilters.contribution * 100) / selectedFilters.price),
                property_price: selectedFilters.price,
                view_type: CreditAlgolyticsViewType.BANK_OFFERS
            });
        }

        setFilters(selectedFilters);
    };

    return (
        <div css={[mt(1), mb(6)]}>
            <CreditOffersFilters onFiltersSet={onFiltersSet} />

            <CreditOffersList filters={filters} />
        </div>
    );
};
import {useState} from "react";

import {mb, mt} from "@pg-design/helpers-css";

import {CreditValuesEvent} from "../../tracking/analytics/credit_values_event";
import {CreditAlgolyticsViewType} from "../../tracking/types/CreditAlgolyticsViewType";
import {ICreditOffersFilters} from "../../types/ICreditOffersFilters";
import {CreditOffersFilters} from "./CreditOffersFilters";
import {CreditOffersList} from "./CreditOffersList";

export const CreditOffers = () => {
    const [filters, setFilters] = useState<ICreditOffersFilters>({} as ICreditOffersFilters);

    const onFiltersSet = (selectedFilters: ICreditOffersFilters, initialSet?: boolean) => {
        if (!initialSet) {
            CreditValuesEvent({
                credit_period: selectedFilters.period,
                own_contribution_amount: selectedFilters.contribution,
                own_contribution_percent: Math.floor((selectedFilters.contribution * 100) / selectedFilters.price),
                property_price: selectedFilters.price,
                view_type: CreditAlgolyticsViewType.BANK_OFFERS
            });
        }

        setFilters(selectedFilters);
    };

    return (
        <div css={[mt(1), mb(6)]}>
            <CreditOffersFilters onFiltersSet={onFiltersSet} />

            <CreditOffersList filters={filters} />
        </div>
    );
};
